/**
 * Adjuntos de solicutud de pago
 *
 */
import React from 'react';
import { Table, Button, Modal } from 'antd';
import numeral from 'numeral';
import Cell from '../../../components/Cell';
import Api from '../../../Api';
import Exception from '../../../Exception';

export default class Pagos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.columns = Cell.buildList([
      { width: '25%', title: 'ORDEN COMPRA / SERVICIO', dataIndex: 'factura.ordenCompra.sConsecutivo' },
      { width: '25%', title: 'ENTRADA', dataIndex: 'factura.entrada.sConsecutivo' },
      { width: '25%', title: 'REFERENCIA', dataIndex: 'factura.sReferencia' },
      { width: '25%', title: 'IMPORTE', dataIndex: 'dImporte', render: val => numeral(val).format('$0,0.00') },
    ]);

    this.state = {
      templates: [],
      data: [],
      loading: false,
      pagoId: 0,
    };

    this.load = this.load.bind(this);
  }

  /**
   * Load
   *
   * @param {Number} pagoId
   */
  load(pagoId) {
    this.setState({
      visible: true,
      loading: true,
      data: [],
      pagoId,
    });

    const query = {
      model: 'TesPagoFactura',
      attributes: [
        'iId',
        'dImporte'
      ],
      include: [
        {
          as: 'factura',
          required: false,
          attributes: ['sReferencia'],
          include: [
            { as: 'ordenCompra', attributes: ['sConsecutivo'] },
            { as: 'entrada', attributes: ['sConsecutivo'] },
          ]
        },

        {
          as: 'facturaSub',
          required: false,
          attributes: ['sReferencia'],
          include: [
            { as: 'ordenCompra', attributes: ['sConsecutivo'] },
          ]
        }
      ],
      where: {
        iIdPago: pagoId
      }
    };

    Api.query(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data.map(r => {
            return {
              ...r,
              factura: r.factura || r.facturaSub,
            }
          }),
        })
      )
      .catch(error => {
        this.setState({ loading: false });
        Exception.load(error).show();
      });
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='DETALLE DE PAGO'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '70%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='guardar'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        }
      />
    );
  }
}
